import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const ExternalLink = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function ExternalLink({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 4.25C4.58579 4.25 4.25 4.58579 4.25 5V19C4.25 19.4142 4.58579 19.75 5 19.75H19C19.4142 19.75 19.75 19.4142 19.75 19V13.5C19.75 13.2239 19.9739 13 20.25 13H20.75C21.0261 13 21.25 13.2239 21.25 13.5V19C21.25 20.2426 20.2426 21.25 19 21.25H5C3.75736 21.25 2.75 20.2426 2.75 19V5C2.75 3.75736 3.75736 2.75 5 2.75H10.5C10.7761 2.75 11 2.97386 11 3.25V3.75C11 4.02614 10.7761 4.25 10.5 4.25H5Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.5001 3.25C13.5001 2.97386 13.7239 2.75 14.0001 2.75H21.2501V10C21.2501 10.2761 21.0262 10.5 20.7501 10.5H20.2501C19.9739 10.5 19.7501 10.2761 19.7501 10V5.31066L12.3839 12.6768C12.1887 12.872 11.8721 12.872 11.6768 12.6768L11.3233 12.3232C11.128 12.128 11.128 11.8114 11.3233 11.6161L18.6894 4.25H14.0001C13.7239 4.25 13.5001 4.02614 13.5001 3.75V3.25Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'external-link-icon-svg'} iconRender={iconRender} {...props} />;
});

export default ExternalLink;
